export const MissingParameterPreviewLimit = 4;

export function formatMissingParameterPreview(
  names: string[],
  limit = MissingParameterPreviewLimit
): string | null {
  if (names.length === 0) {
    return null;
  }

  const visibleNames = names.slice(0, limit).join(', ');
  const hiddenCount = names.length - limit;
  return hiddenCount > 0 ? `${visibleNames}, +${hiddenCount} more` : visibleNames;
}
